// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-header li a{
    color: #000;
}
.page-header{
    margin-bottom: 20px;
}
.page-header h1, .page-header h2{
    font-weight: 700;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInBhZ2UtaGVhZGVyLmNvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7SUFDSSxXQUFXO0FBQ2Y7QUFDQTtJQUNJLG1CQUFtQjtBQUN2QjtBQUNBO0lBQ0ksZ0JBQWdCO0FBQ3BCIiwiZmlsZSI6InBhZ2UtaGVhZGVyLmNvbXBvbmVudC5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyIucGFnZS1oZWFkZXIgbGkgYXtcbiAgICBjb2xvcjogIzAwMDtcbn1cbi5wYWdlLWhlYWRlcntcbiAgICBtYXJnaW4tYm90dG9tOiAyMHB4O1xufVxuLnBhZ2UtaGVhZGVyIGgxLCAucGFnZS1oZWFkZXIgaDJ7XG4gICAgZm9udC13ZWlnaHQ6IDcwMDtcbn0iXX0= */`, "",{"version":3,"sources":["webpack://./src/app/shared/components/page-header/page-header.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;AACf;AACA;IACI,mBAAmB;AACvB;AACA;IACI,gBAAgB;AACpB;AACA,ggBAAggB","sourcesContent":[".page-header li a{\n    color: #000;\n}\n.page-header{\n    margin-bottom: 20px;\n}\n.page-header h1, .page-header h2{\n    font-weight: 700;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
